import { useTheme } from "@mui/system";

export default function RecipeIcon({size = 40}) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 32;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg 
      width={baseWidth}
      height={height} 
      viewBox="0 0 40 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.77801 0C3.47927 0 0 3.47927 0 7.77801V23.334C0 27.6328 3.47927 31.112 7.77801 31.112C12.0768 31.112 15.556 27.6328 15.556 23.334V7.77801C15.556 3.47927 12.0768 0 7.77801 0ZM11.1114 15.556H4.44458V7.77801C4.44458 5.93768 5.93768 4.44458 7.77801 4.44458C9.61834 4.44458 11.1114 5.93768 11.1114 7.77801V15.556ZM20.8131 13.4935C20.5701 13.2504 20.1603 13.2782 19.9589 13.549C16.813 17.8894 17.1533 23.9729 21.0631 27.8828C24.973 31.7926 31.0565 32.1329 35.3969 28.987C35.6747 28.7856 35.6955 28.3759 35.4525 28.1328L20.8131 13.4935ZM36.7719 12.174C32.8621 8.26414 26.7786 7.92385 22.4382 11.0698C22.1604 11.2712 22.1396 11.6809 22.3826 11.924L37.0219 26.5633C37.265 26.8064 37.6747 26.7786 37.8761 26.5077C41.0221 22.1604 40.6887 16.0838 36.7719 12.174Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>
  )
}